import { useEffect, useState } from "react";
import { getReferenceTables } from "../../api/reference";
import { ReferenceTable } from "../../types/interfaces/admin";
import { useErrorHandler } from "../Error/useErrorHandler";

export function useReferenceSchemas(enabled: boolean) {
  const handleError = useErrorHandler();
  const [schemas, setSchemas] = useState<Record<string, ReferenceTable[]>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enabled) return;

    setLoading(true);

    async function fetchSchemas() {
      try {
        const tables = await getReferenceTables();
        const grouped = tables.reduce((acc, table) => {
          if (!acc[table.schemaName]) acc[table.schemaName] = [];
          acc[table.schemaName].push(table);
          return acc;
        }, {} as Record<string, ReferenceTable[]>);
        setSchemas(grouped);
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    }

    fetchSchemas();
  }, [enabled]);

  return { schemas, loading };
}
